import { fork } from 'redux-saga/effects';
import {
  rootCommonSagas,
  rootAuthSaga,
  rootDepartmentSaga,
  rootDesignationSaga,
  rootSidebarSaga,
  rootQualificationSaga,
  rootTrainingCertificatesSaga,
  rootDropdownMasterSaga,
  rootPositionSaga,
  rootMrfSaga,
  rootLocationSaga,
  rootEmployeeSaga,
  rootMrfInterviewSaga,
  rootShiftSaga,
  rootEmailTemplate,
  rootOnboardingSaga,
  rootCandidateSaga,
  rootLeaveSaga,
  rootPoliciesSaga,
  rootBranchSaga,
  rootHolidaySaga,
  rootattendanceDashboardSaga,
  rootPermissionSaga,
  rootRolesSaga,
  rootAttendanceCorrectionSaga,
  rootApprovalManagementSaga,
  rootPayrollSaga,
  rootCommunitySagas,
  rootClientSaga,
  rootFeedbackSaga,
  rootKudosSaga,
  rootTravelAndClaimSaga,
  rootFinancialYearSaga,
  rootPMSSaga,
  rootDashboardSaga,
  rootTaskManagementSaga,
  rootSeparationSaga,
  rootAssetsSaga,
  rootTicketManagementSaga,
  rootMoodRatingSaga,
  rootReportSaga,
  rootNotificationSaga,
  rootBulkUploadSaga
} from './sagas';
import rootOtherAttendanceSaga from './sagas/otherAttendanceSagas';



function* rootSaga() {
  yield fork(rootCommonSagas);
  yield fork(rootAuthSaga);
  yield fork(rootDepartmentSaga);
  yield fork(rootDesignationSaga);
  yield fork(rootEmailTemplate);
  yield fork(rootSidebarSaga);
  yield fork(rootOnboardingSaga);
  yield fork(rootShiftSaga);
  yield fork(rootQualificationSaga);
  yield fork(rootTrainingCertificatesSaga);
  yield fork(rootDropdownMasterSaga)
  yield fork(rootPositionSaga);
  yield fork(rootMrfSaga);
  yield fork(rootLocationSaga);
  yield fork(rootEmployeeSaga);
  yield fork(rootMrfInterviewSaga);
  yield fork(rootCandidateSaga);
  yield fork(rootLeaveSaga);
  yield fork(rootPoliciesSaga);
  yield fork(rootBranchSaga);
  yield fork(rootHolidaySaga);
  yield fork(rootattendanceDashboardSaga);
  yield fork(rootPermissionSaga);
  yield fork(rootRolesSaga);
  yield fork(rootAttendanceCorrectionSaga);
  yield fork(rootApprovalManagementSaga);
  yield fork(rootPayrollSaga);
  yield fork(rootOtherAttendanceSaga);
  yield fork(rootCommunitySagas);
  yield fork(rootClientSaga);
  yield fork(rootFeedbackSaga);
  yield fork(rootKudosSaga)
  yield fork(rootTravelAndClaimSaga)
  yield fork(rootFinancialYearSaga)
  yield fork(rootPMSSaga)
  yield fork(rootDashboardSaga)
  yield fork(rootTaskManagementSaga)
  yield fork(rootAssetsSaga)
  yield fork(rootSeparationSaga)
  yield fork(rootTicketManagementSaga)
  yield fork(rootMoodRatingSaga)
  yield fork(rootReportSaga)
  yield fork(rootNotificationSaga)
  yield fork(rootBulkUploadSaga)
}

export default rootSaga;